import React, { Fragment, useEffect, useState } from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';
import { InvitedFromOtherDomainName } from './InvitedFromOtherDomainName';
import BootstrapTable from '../../components/react-bootstrap-table-next/react-bootstrap-table2';
import filterFactory from '../../components/react-bootstrap-table-next/react-bootstrap-table2-filter';
import paginationFactory from '../../components/react-bootstrap-table-next/react-bootstrap-table2-paginator';
import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableHeader } from '../../components/TableHeader/TableHeader';
import createNotification from '../../utils/createNotification';
import './AssociateMembersTable.scss';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import AssociateMemberModal from './Modal/AssociateMemberModal';
import { useLocation } from 'react-router-dom';
import { HomeButton } from '../../components/HomeButton/home-button';
import { useStateSelector } from '../../store/selectors';
import {
    getDefaultAssosiateMemberRights,
    getMappedAssosiateMemberRights,
} from '../../utils/associateMembersConstants';
import { GRANT_ACTING_PRIMARY_CONFIRMATION_TEXT } from '../../utils/associateMembersConstants';
import { PRACTICE_STATUS_ENUM, USER_ROLES } from '../../utils/constants';
import { PRACTICE_OWNERSHIP_TYPES } from '../../utils/constants/PracticeOwnerType.enum';
import { DialogMode, TeamMemberModal } from './Modal/TeamMemberModal';
import { useDispatch } from 'react-redux';
import { GetAvailableOpportunitiesForTeamMembers } from '../../slices/marketplace/opportunity/thunks/get-availalble-opportunities-for-team-members.thunk';
import {
    ExternalPermissionsOptionList,
    ExternalTeamMemberRoleOptionList,
    InternalPermissionsOptionList,
    InternalTeamMemberRoleOptionList,
    InternalTeamMemberRole,
    TeamMemberType,
} from '../Admin/BuyerMarketplace/MyTeamMembers/Models/Enums';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';

const DefaultAssociateMemberObject = {
    name: '',
    email: '',
    status: '',
    practices: [],
    nonprofitMapping: {
        accessRights: getDefaultAssosiateMemberRights(),
    },
    associateMemberMarketplaceMappings: [
        {
            type: null,
            role: null,
            permissions: null,
            isGeneralSettings: true,
        },
    ],
};

export const AssociateMembersTable = (props) => {
    const axios = useStateSelector((state) => state.core.axios);
    const search = useLocation().search;
    const [page, setPage] = useState(0);
    const [tableData, setTableData] = useState([]);
    const [totalSize, setTotalSize] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [associateMemberDialogVisible, setAssociateMemberDialogVisible] =
        useState(false);
    const [associateMemberDialogMode, setAssociateMemberDialogMode] =
        useState(undefined);
    const [associateMemberData, setAssociateMemberData] = useState(
        DefaultAssociateMemberObject
    );
    const [isCurrentUserNonprofitAdmin, setIsCurrentUserNonprofitAdmin] =
        useState(false);

    const [projectsAvailability, setProjectsAvailability] = useState([]);
    const [opportunityTableUpdateTrigger, setOpportunityTableUpdateTrigger] =
        useState(0);
    const [tableSettings, setTableSettings] = useState(null);
    const [selectedAssociateMember, setSelectedAssociateMember] =
        useState(undefined);
    const [pendingGrantMemberId, setPendingGrantMemberId] = useState(null);
    const [isGrantConfirmationVisible, setIsGrantConfirmationVisible] =
        useState(false);
    const [isActingPrimaryLoading, setIsActingPrimaryLoading] = useState(false);

    const limits = useStateSelector((state) => state.currentUser.limits);
    const summary = useStateSelector((state) => state.userSummary.summary);
    const buyerProfile = useStateSelector(
        (state) => state.buyersState.targetBuyer
    );
    const isPrimaryBuyer =
        buyerProfile?.teamMemberRole?.isPrimaryBuyer ?? false;
    const isRealPrimaryBuyer =
        isPrimaryBuyer && summary?.roleId === USER_ROLES.USER;

    const [isFormerPrimaryMember, setIsFormerPrimaryMember] = useState(false);

    useEffect(() => {
        const hasActingPrimaryMember = () =>
            tableData.some((row) =>
                row.associateMemberMarketplaceMappings?.some(
                    (m) => m.isGeneralSettings && m.isActingPrimaryBuyer
                )
            );
        setIsFormerPrimaryMember(
            isRealPrimaryBuyer && hasActingPrimaryMember()
        );
    }, [tableData, isRealPrimaryBuyer]);

    const defaultSorted = [
        {
            dataField: 'name',
            order: 'asc',
        },
    ];
    const [loadWithParameter, setLoadWithParameter] = useState(true);
    const dispatch = useDispatch();

    const fetchEngagedOpportunities = () => {
        dispatch(
            GetAvailableOpportunitiesForTeamMembers(
                props.isAdminView ? props.currentUserId : undefined
            )
        );
    };

    const handleTableChange = (type, newState) => {
        let sortField = newState.sortField;
        let sortOrder = newState.sortOrder;
        let page = newState.page;
        let sizePerPage = newState.sizePerPage;

        let fetchObj = {
            Filter: {
                Filters: [],
                Logic: '',
            },
            PageNumber: page,
            PageSize: sizePerPage,
            Sort: {
                Dir: sortOrder,
                Field: sortField,
            },
        };

        const arrayOfObj = Object.entries(newState.filters).map((e) => ({
            [e[0]]: e[1],
        }));

        if (arrayOfObj.length > 0) {
            arrayOfObj.forEach((element) => {
                let key = Object.keys(element);

                let values = newState.filters[key];

                let obj = {
                    Field: key[0],
                    Operator: 'contains',
                    Value: values.filterVal,
                };

                fetchObj.Filter.Filters.push(obj);
            });
        }

        setTableSettings(fetchObj);
        fetchUsersData(fetchObj);
    };

    useEffect(() => {
        setIsCurrentUserNonprofitAdmin(
            props.summaryData.roleId === USER_ROLES.CHARITY_ADMIN
        );
        if (props.isMarketplaceBuyer) {
            fetchEngagedOpportunities();
        }
        fetchDataRequestProjectAvailability();
    }, []);

    useEffect(() => {
        if (props?.membersDataRefreshTrigger && tableSettings) {
            fetchUsersData(tableSettings);
        }
    }, [props.membersDataRefreshTrigger]);

    useEffect(() => {
        if (selectedAssociateMember) {
            viewAssociate(selectedAssociateMember);
        }
    }, [selectedAssociateMember]);

    useEffect(() => {
        const id = new URLSearchParams(search).get('id');
        if (id && loadWithParameter && tableData.length > 0) {
            setSelectedAssociateMember(id);
            setLoadWithParameter(false);
        }
    }, [tableData]);

    const fetchDataRequestProjectAvailability = () => {
        axios
            .get(
                `api/DataRequestProjects/affiliateProjectsAccess?ownerId=${props.currentUserId}`
            )
            .then((response) => {
                if (response.status === 200) {
                    setProjectsAvailability(response.data);
                }
            });
    };

    const fetchUsersData = (postObj) => {
        const id = new URLSearchParams(search).get('id');
        if (id && postObj && loadWithParameter) {
            postObj = {
                ...postObj,
                Filter: {
                    ...postObj.Filter,
                    Filters: [{ Field: 'id', Operator: 'eq', Value: id }],
                },
            };
        }
        axios
            .post('/api/Associate/get', {
                requestModel: postObj,
                userID: props.currentUserId,
            })
            .then((response) => {
                if (response && response.data && response.data.isError) {
                    createNotification(
                        'Could not fetch Users at the moment. Please try again later or contact the Administrator',
                        'error'
                    );
                } else {
                    if (response.data.message == 'No data found.') {
                        setTableData([]);
                    } else {
                        let userData = response.data.data;
                        if (props.currentUserId) {
                            // remove current user from list of users
                            let res = userData.list.filter(
                                (x) => x.id != props.currentUserId
                            );
                            setTableData(res);
                        } else {
                            setTableData(userData.list);
                        }
                        setPage(userData.pageNumber);
                        setTotalSize(userData.totalItems);
                        setSizePerPage(userData.pageSize);
                        localStorage['filter'] = JSON.stringify(postObj);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                setTableData([]);
            });
    };

    const viewAssociate = (cellContent) => {
        const user = tableData.find((u) => u.id == cellContent);
        if (isCurrentUserNonprofitAdmin) {
            const nonprofitMapping = user.nonprofitMapping;
            nonprofitMapping.accessRights = getMappedAssosiateMemberRights(
                nonprofitMapping?.associateMemberAccessRights
            );
            setAssociateMemberData({
                id: user.id,
                name: user.name,
                email: user.email,
                status: user.status,
                practices: [],
                nonprofitMapping: nonprofitMapping,
                associateMemberMarketplaceMappings: [
                    {
                        type: null,
                        role: null,
                        permissions: null,
                        isGeneralSettings: true,
                    },
                ],
            });
        } else {
            const practices = (props.summaryData.practices || [])
                .filter((p) => p.status == 1)
                .map((p) => {
                    const practice = user.practices.find(
                        (pr) => pr.practiceId == p.id
                    );
                    const pr = {
                        practiceId: p.id,
                        name: p.name,
                        isSelected: !!practice,
                        roleId: practice ? practice.roleId : '',
                        accessRights: getMappedAssosiateMemberRights(
                            practice?.accessRights
                        ),
                        cannotBePmgRepresentative: tableData.some(
                            (td) =>
                                !getMappedAssosiateMemberRights(
                                    practice?.accessRights
                                ).pmgRepresentativeAccessRights &&
                                td.practices.some(
                                    (prac) =>
                                        prac.practiceId === p.id &&
                                        getMappedAssosiateMemberRights(
                                            prac.accessRights
                                        ).pmgRepresentativeAccessRights
                                )
                        ),
                        availableDataRequestProjects:
                            projectsAvailability.filter(
                                (project) =>
                                    project.isAvailable &&
                                    (project.practiceId === p.id ||
                                        project.marketplaceRelatedPracticeIds.some(
                                            (x) => x == p.id
                                        ))
                            ),
                    };
                    pr.accessRights.referralPartnerExtension =
                        user.practices.some(
                            (p) =>
                                pr.isSelected &&
                                getMappedAssosiateMemberRights(p.accessRights)
                                    .referralPartnerExtension
                        );
                    return pr;
                });
            let marketplaceMapping = user.associateMemberMarketplaceMappings;
            setAssociateMemberData({
                id: user.id,
                name: user.name,
                email: user.email,
                status: user.status,
                practices: practices,
                nonprofitMapping: null,
                associateMemberMarketplaceMappings: marketplaceMapping ?? [
                    {
                        type: null,
                        role: null,
                        permissions: null,
                        isGeneralSettings: true,
                    },
                ],
            });
        }
        setAssociateMemberDialogMode(DialogMode.View);
        setAssociateMemberDialogVisible(true);
    };

    const addAssociate = () => {
        const defaultAssociate = {
            name: '',
            email: '',
            status: undefined,
            associateMemberMarketplaceMappings: [
                {
                    type: null,
                    role: null,
                    permissions: null,
                    isGeneralSettings: true,
                },
            ],
            practices: isCurrentUserNonprofitAdmin
                ? []
                : (props.summaryData.practices || [])
                      .filter(
                          (p) =>
                              p.status == PRACTICE_STATUS_ENUM.Approved &&
                              p.practiceOwnershipType !=
                                  PRACTICE_OWNERSHIP_TYPES.FORMER
                      )
                      .map((practice) => ({
                          practiceId: practice.id,
                          name: practice.name,
                          isSelected: false,
                          roleId: 0,
                          accessRights: getDefaultAssosiateMemberRights(),
                          cannotBePmgRepresentative: tableData.some(
                              (td) =>
                                  !getMappedAssosiateMemberRights(
                                      practice?.accessRights
                                  ).pmgRepresentativeAccessRights &&
                                  td.practices.some(
                                      (prac) =>
                                          prac.practiceId === practice.id &&
                                          getMappedAssosiateMemberRights(
                                              prac.accessRights
                                          ).pmgRepresentativeAccessRights
                                  )
                          ),
                          availableDataRequestProjects:
                              projectsAvailability.filter(
                                  (project) =>
                                      project.isAvailable &&
                                      (project.practiceId === practice.id ||
                                          project.marketplaceRelatedPracticeIds.some(
                                              (x) => x == practice.id
                                          ))
                              ),
                      })),
        };
        if (isCurrentUserNonprofitAdmin) {
            defaultAssociate.nonprofitMapping = {
                accessRights: getDefaultAssosiateMemberRights(),
            };
        }
        setAssociateMemberData(defaultAssociate);
        setAssociateMemberDialogMode(DialogMode.Create);
        setAssociateMemberDialogVisible(true);
    };

    const isCurrentUserAdmin = summary?.roleId === USER_ROLES.ADMIN;
    const canAdminAddTeamMembers =
        props.isMarketplaceBuyer ||
        props.summaryData?.roleId === USER_ROLES.PRACTICE_OWNER ||
        props.summaryData?.roleId === USER_ROLES.CHARITY_ADMIN;
    const canAddTeamMembers = props.isAdminView
        ? canAdminAddTeamMembers
        : !isCurrentUserAdmin;

    const buttons = !canAddTeamMembers
        ? []
        : [
              {
                  buttonText: '+ Add New Team Member',
                  onClick: addAssociate,
                  disabled: isFormerPrimaryMember,
              },
          ];

    const resetAssociateDialog = () => {
        setSelectedAssociateMember(undefined);
        setAssociateMemberDialogVisible(false);
        setAssociateMemberData(DefaultAssociateMemberObject);
        setAssociateMemberDialogMode(undefined);
    };

    const handleGrantCheckboxClick = (teamMemberId) => {
        setPendingGrantMemberId(teamMemberId);
        setIsGrantConfirmationVisible(true);
    };

    const handleGrantConfirm = () => {
        setIsActingPrimaryLoading(true);
        axios
            .post('/api/Marketplace/ActingPrimaryBuyer/Grant', {
                teamMemberId: pendingGrantMemberId,
            })
            .then(() => {
                fetchUsersData(tableSettings);
                setIsGrantConfirmationVisible(false);
            })
            .catch(() => {
                createNotification(
                    'Could not grant Active Primary Representative permissions. Please try again later or contact the Administrator.',
                    'error'
                );
            })
            .finally(() => {
                setIsActingPrimaryLoading(false);
                setPendingGrantMemberId(null);
            });
    };

    const handleRevoke = (teamMemberId) => {
        setIsActingPrimaryLoading(true);
        axios
            .post('/api/Marketplace/ActingPrimaryBuyer/Revoke', {
                teamMemberId: teamMemberId,
            })
            .then(() => {
                fetchUsersData(tableSettings);
            })
            .catch(() => {
                createNotification(
                    'Could not revoke Active Primary Representative permissions. Please try again later or contact the Administrator.',
                    'error'
                );
            })
            .finally(() => {
                setIsActingPrimaryLoading(false);
            });
    };

    const handleGrantCancel = () => {
        setPendingGrantMemberId(null);
        setIsGrantConfirmationVisible(false);
    };

    const getColumns = () => [
        {
            dataField: 'name',
            text: 'Name',
            sort: true,
            formatExtraData: tableData.map((member) => member.id),
            formatter: (cellContent, row, rowIndex, memberIdsOnPage) => (
                <InvitedFromOtherDomainName
                    name={cellContent}
                    isInvitedFromOtherDomain={row.isInvitedFromOtherDomain}
                    isIndented={
                        !!row.invitedByMemberId &&
                        memberIdsOnPage.includes(row.invitedByMemberId)
                    }
                />
            ),
        },
        {
            hidden: !isRealPrimaryBuyer,
            dataField: 'actingPrimaryMember',
            text: 'Active Primary Representative',
            sort: false,
            formatter: (_, row) => {
                const generalSettings =
                    row.associateMemberMarketplaceMappings?.find(
                        (mapping) => mapping.isGeneralSettings
                    );
                if (!generalSettings) return null;
                const isPrimaryMemberRow =
                    generalSettings.internalRole ===
                    InternalTeamMemberRole.PrimaryMember;
                const isInternalMember =
                    generalSettings.type === TeamMemberType.Internal;
                const isCurrentUserPrimaryBuyer = isPrimaryBuyer;

                if (isPrimaryMemberRow) {
                    return (
                        <input type="checkbox" checked={true} disabled={true} />
                    );
                }

                if (isInternalMember) {
                    const isActingPrimary =
                        generalSettings.isActingPrimaryBuyer === true;
                    return (
                        <input
                            type="checkbox"
                            checked={isActingPrimary}
                            disabled={
                                !isCurrentUserPrimaryBuyer ||
                                isActingPrimaryLoading
                            }
                            onChange={() => {
                                if (isCurrentUserPrimaryBuyer) {
                                    if (isActingPrimary) {
                                        handleRevoke(row.id);
                                    } else {
                                        handleGrantCheckboxClick(row.id);
                                    }
                                }
                            }}
                        />
                    );
                }

                return null;
            },
        },
        {
            dataField: 'status',
            text: 'Status',
            sort: true,
        },
        {
            hidden: !props.isMarketplaceBuyer,
            dataField: 'role',
            text: 'Role',
            sort: true,
            formatter: (_, row) => {
                const marketplaceMappings =
                    row.associateMemberMarketplaceMappings;
                if (!marketplaceMappings) return 'NA';
                const generalSettings = marketplaceMappings.find(
                    (mapping) => mapping.isGeneralSettings
                );
                if (!generalSettings) return 'NA';
                if (generalSettings.isActingPrimaryBuyer)
                    return 'Active Primary Representative';
                const role =
                    generalSettings.type === TeamMemberType.Internal
                        ? generalSettings.internalRole
                        : generalSettings.externalRole;
                const label =
                    generalSettings.type === TeamMemberType.Internal
                        ? InternalTeamMemberRoleOptionList.find(
                              (x) => x.value === role
                          )?.label
                        : ExternalTeamMemberRoleOptionList.find(
                              (x) => x.value === role
                          )?.label;
                return label ?? 'NA';
            },
        },
        {
            hidden: !props.isMarketplaceBuyer,
            dataField: 'permissionLevel',
            text: 'Permission Level',
            sort: false,
            formatter: (_, row) => {
                const generalSettings =
                    row.associateMemberMarketplaceMappings?.find(
                        (mapping) => mapping.isGeneralSettings
                    );
                if (!generalSettings) return null;
                const optionList =
                    generalSettings.type === TeamMemberType.Internal
                        ? InternalPermissionsOptionList
                        : ExternalPermissionsOptionList;
                const permission =
                    generalSettings.type === TeamMemberType.Internal
                        ? generalSettings.internalPermissions
                        : generalSettings.externalPermissions;
                return (
                    optionList.find((x) => x.value === permission)
                        ?.shortLabel ?? null
                );
            },
        },
        {
            dataField: 'createdOn',
            text: 'Registered Date',
            sort: true,
            formatter: (cellContent) =>
                cellContent
                    ? new Date(cellContent).toLocaleString('en-US')
                    : '',
        },
        {
            dataField: 'id',
            text: 'Action',
            sort: false,
            formatter: (cellContent, row) => {
                const isCurrentUserActingPrimary =
                    isPrimaryBuyer && !isRealPrimaryBuyer;
                const isOwnRow =
                    isCurrentUserActingPrimary &&
                    row.userId === props.currentUserId;

                if (isOwnRow) {
                    return null;
                }

                return (
                    <>
                        <div
                            style={{ textAlign: 'center' }}
                            className="d-block w-100 edit-col">
                            <span
                                className="icon-hover-style"
                                onClick={() =>
                                    setSelectedAssociateMember(cellContent)
                                }>
                                <FontAwesomeIcon icon={faWrench} />
                            </span>
                        </div>
                    </>
                );
            },
        },
    ];

    return (
        <Fragment>
            {summary.roleId !== USER_ROLES.PRACTICE_OWNER ||
            (limits.doesSupportSubscriptions && limits.hasPaidSubscription) ? (
                <div className="associate-members-table">
                    {!props.isShortView && (
                        <>
                            <div className="page-title">
                                <h3>My Team Members</h3>
                            </div>
                            <Breadcrumb>
                                <BreadcrumbItem>
                                    <HomeButton />
                                </BreadcrumbItem>
                                <BreadcrumbItem active>
                                    My Team Members
                                </BreadcrumbItem>
                            </Breadcrumb>
                        </>
                    )}
                    <div className="body_white_box associate_member">
                        <div className="body_header_title">
                            <h5>
                                {'Team Members'}
                                <TableHeader
                                    hasToolbar={true}
                                    buttons={buttons}
                                />
                            </h5>
                        </div>
                        {tableData ? (
                            <Row className="associate_data">
                                <Col md="12">
                                    <Card className="main-card mb-3">
                                        <CardBody>
                                            <div className="associate-member-list-table">
                                                <BootstrapTable
                                                    bootstrap4
                                                    remote
                                                    keyField="id"
                                                    data={tableData}
                                                    columns={getColumns()}
                                                    defaultSorted={
                                                        defaultSorted
                                                    }
                                                    filter={filterFactory()}
                                                    pagination={paginationFactory(
                                                        {
                                                            page,
                                                            sizePerPage,
                                                            totalSize,
                                                        }
                                                    )}
                                                    onTableChange={
                                                        handleTableChange
                                                    }
                                                    noDataIndication="No Users available"
                                                />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        ) : (
                            ''
                        )}
                        {associateMemberDialogVisible ? (
                            props.isMarketplaceBuyer ? (
                                <TeamMemberModal
                                    isVisible={associateMemberDialogVisible}
                                    setIsVisible={() => {
                                        setAssociateMemberDialogVisible();
                                        setSelectedAssociateMember(undefined);
                                    }}
                                    isReadonly={
                                        isFormerPrimaryMember ||
                                        (props.isAdminView &&
                                            associateMemberData.associateMemberMarketplaceMappings?.find(
                                                (m) => m.isGeneralSettings
                                            )?.isActingPrimaryBuyer === true)
                                    }
                                    dialogMode={associateMemberDialogMode}
                                    setDialogMode={setAssociateMemberDialogMode}
                                    resetDialog={resetAssociateDialog}
                                    data={associateMemberData}
                                    getSummaryData={props.getSummaryData}
                                    currentUserId={props.currentUserId}
                                    isAdminView={props.isAdminView}
                                    summaryData={props.summaryData}
                                    setData={(p) => {
                                        setAssociateMemberData(p);
                                    }}
                                    opportunityTableUpdateTrigger={
                                        opportunityTableUpdateTrigger
                                    }
                                    setOpportunityTableUpdateTrigger={
                                        setOpportunityTableUpdateTrigger
                                    }
                                    refreshTable={() => {
                                        fetchUsersData(tableSettings);
                                    }}
                                />
                            ) : (
                                <AssociateMemberModal
                                    isVisible={associateMemberDialogVisible}
                                    setIsVisible={() => {
                                        setAssociateMemberDialogVisible();
                                        setSelectedAssociateMember(undefined);
                                    }}
                                    dialogMode={associateMemberDialogMode}
                                    setDialogMode={setAssociateMemberDialogMode}
                                    resetDialog={resetAssociateDialog}
                                    data={associateMemberData}
                                    getSummaryData={props.getSummaryData}
                                    currentUserId={props.currentUserId}
                                    isAdminView={props.isAdminView}
                                    summaryData={props.summaryData}
                                    setData={(p) => {
                                        setAssociateMemberData(p);
                                    }}
                                    refreshTable={() => {
                                        fetchUsersData(tableSettings);
                                    }}
                                />
                            )
                        ) : (
                            []
                        )}
                    </div>
                </div>
            ) : (
                <div className="text-center mt-5">
                    <h3>Access restricted</h3>
                </div>
            )}
            <ConfirmationModal
                isVisible={isGrantConfirmationVisible}
                setIsVisible={setIsGrantConfirmationVisible}
                header="Confirm Primary Member Permissions"
                confirmationText={GRANT_ACTING_PRIMARY_CONFIRMATION_TEXT}
                nextButtonText="Confirm"
                cancelButtonText="Cancel"
                isConfirmationDanger={false}
                isLoading={isActingPrimaryLoading}
                closeOnConfirm={false}
                onConfirm={handleGrantConfirm}
                onCancel={handleGrantCancel}
            />
        </Fragment>
    );
};
export default AssociateMembersTable;
